import { IError } from '../base/error'
import ServiceBase from '../base/service.base'

import {
  IOrderProductionDetails,
  IOrderProductionPaginatedResponse,
  IOrderProductionStepsResponse,
  IOrderProductionsStatisticsResponse,
  OrderProductionStatus,
} from './order-production.types'

export class OrderProduction extends ServiceBase {
  public async getOrderProductionSteps(
    id: string,
  ): Promise<IOrderProductionStepsResponse> {
    const url = `/order-production/steps/${id}`

    const response = await this.request.get<
      IOrderProductionStepsResponse,
      IError
    >(url)

    if (response.result) {
      return response.result
    } else {
      const error = response.error as IError
      throw new IError(error.statusCode, error.message, error.error)
    }
  }

  public async getOrderProductions(
    page?: number,
    limit?: number,
    status?: OrderProductionStatus,
    code?: string,
  ): Promise<IOrderProductionPaginatedResponse> {
    const url = `/order-production`

    const response = await this.request.get<
      IOrderProductionPaginatedResponse,
      IError
    >(url, {
      params: {
        page,
        limit,
        status,
        code,
      },
    })

    if (response.result) {
      return response.result
    } else {
      const error = response.error as IError
      throw new IError(error.statusCode, error.message, error.error)
    }
  }

  public async getOrderProductionsStatistics(): Promise<IOrderProductionsStatisticsResponse> {
    const url = '/order-production/statistics'

    const response = await this.request.get<
      IOrderProductionsStatisticsResponse,
      IError
    >(url)

    if (response.result) {
      return response.result
    } else {
      const error = response.error as IError
      throw new IError(error.statusCode, error.message, error.error)
    }
  }

  public async getOrderProduction(
    code: string,
  ): Promise<IOrderProductionDetails> {
    const url = `/order-production/${code}`

    const response = await this.request.get<IOrderProductionDetails, IError>(
      url,
    )

    if (response.result) {
      return response.result
    } else {
      const error = response.error as IError
      throw new IError(error.statusCode, error.message, error.error)
    }
  }
}
